import { serializeToJSX } from '@/lib/serializeTiptap';

import ControlledField from '../../ControlledField';
import FormCheckbox from '../../FormCheckbox';
import FormNote from '../../FormNote';
import { type FormCustomQuestionProps } from '../types';

const WaiverQuestion = ({ name, label, helpText, isRequired, config }: FormCustomQuestionProps) => (
  <ControlledField name={name}>
    <div>
      <ControlledField.Label isRequired={isRequired}>{label}</ControlledField.Label>
      {helpText && <FormNote>{helpText}</FormNote>}
    </div>
    <div
      className="rounded border border-gray-400 py-2 px-3 overflow-y-scroll rich-text"
      style={{ maxHeight: 180 }}
    >
      {serializeToJSX(config.description)}
    </div>
    <ControlledField.Control as={FormCheckbox} label="I agree" />
    <ControlledField.ErrorMessage />
  </ControlledField>
);

export default WaiverQuestion;
